import styled from "styled-components";

export const FormField = styled("div")`
  margin-bottom: 1em;
`;
